import { ApplicationSourceState } from './application-source-selectors';

const InitialState: ApplicationSourceState = {
  applicationSources: null,
  applicationSourcesLoading: false,
};

export default (state = InitialState, action: { type: string; payload: any }) => {
  switch (action.type) {
    case 'LOAD_APPLICATION_SOURCES_STARTING': {
      return { ...state, applicationSourcesLoading: true };
    }
    case 'LOAD_APPLICATION_SOURCES_SUCCESS': {
      return { ...state, applicationSources: action.payload, applicationSourcesLoading: false };
    }
    case 'LOAD_APPLICATION_SOURCES_FAILURE': {
      return { ...state, applicationSourcesLoading: false };
    }
    default:
      return state;
  }
};
